import { PreguntaExportador } from "../PreguntaExportador";
import { FilasExcel, PreguntasTipoEnum } from "@shared/enums";
import { DatosEncuestaExportar } from "../DatosEncuestaExportar";

export class PreguntaExtraPointsExportador extends PreguntaExportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.EXTRA_POINTS;
    }

    protected generarFilaPregunta(datosEncuesta: DatosEncuestaExportar): Map<FilasExcel, string> {
        const fila = super.generarFilaPregunta(datosEncuesta);
        fila.set(FilasExcel.MIN_MAX, `${datosEncuesta.pregunta.payload.score_earning}`);
        return fila;
    }
}
